import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CompanyDetails } from "../../data/component/models-interfaces/manage-company/company-interface";
@Injectable({
  providedIn: "root",
})
export class SegmentService {
  constructor(private httpClient: HttpClient) {}

  getAllSegment(page: any, limit: any, search?: any) {
    const apiUrl = `${environment.serverEndPoint}/segment/list?page=${page}&limit=${limit}&search=${search?.segmentName || ""}&category=${search?.categoryTitle || ""}&description=${search?.description || ""}`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getSegment(id: any) {
    const apiUrl = `${environment.serverEndPoint}/segment/` + id;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  createSegment(data: any) {
    const apiUrl = `${environment.serverEndPoint}/segment/create`;
    return this.httpClient.post<CompanyDetails>(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  updateSegment(id: any, data: any) {
    const apiUrl = `${environment.serverEndPoint}/segment/update/` + id;
    return this.httpClient.put(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  deleteSegment(id: any, data: boolean) {
    const sendData = { isDeleted: data };
    const apiUrl = `${environment.serverEndPoint}/segment/status-update/` + id;
    return this.httpClient.put(apiUrl, sendData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getDropdownSegment(productCategoryId?:string) {
    const apiUrl = `${environment.serverEndPoint}/segment/dropdown/list`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
  getDropdownSegmentById(productCategoryId?:string) {
    const apiUrl = `${environment.serverEndPoint}/segment/dropdown/list?category=${productCategoryId}`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
  async getDropdownSegmentAsync(productCategoryId?:string): Promise<any> {
    try {
      const apiUrl = `${environment.serverEndPoint}/segment/dropdown/list?category=${productCategoryId}`;
      const response = await this.httpClient.get(apiUrl, {headers: {"Content-Type": "application/json"}}).toPromise();
      return response;
    } catch (error) {
      throw error; 
    }
  }
}
